import { render, staticRenderFns } from "./ConsultantDetailsSummary.vue?vue&type=template&id=1c30d8d0&scoped=true"
import script from "./ConsultantDetailsSummary.vue?vue&type=script&lang=js"
export * from "./ConsultantDetailsSummary.vue?vue&type=script&lang=js"
import style0 from "./ConsultantDetailsSummary.vue?vue&type=style&index=0&id=1c30d8d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c30d8d0",
  null
  
)

export default component.exports